 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import axios from '../../config/axios';
import instancesocial from '../../config/socialaxios'

const apiGetOwnGroupSocial = async (keyword = "") => {
  try {
    const result = await instancesocial.get(`/group`, {
      params: { keyword }
    });
    return result;
  } catch (error) {
    return _optionalChain([error, 'optionalAccess', _ => _.response, 'optionalAccess', _2 => _2.data]);
  }
};

const apiGetGroupEvent = async (courseid, page, limit, orderby, option) => {

  try {
    const result = await axios.get(`/v1/course/${courseid}/group_event?page=${page}&limit=${limit}&order_by=${orderby}&search_option=${option}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      }
    })
    return result
  } catch (error) {
    return _optionalChain([error, 'optionalAccess', _3 => _3.response, 'optionalAccess', _4 => _4.data]);
  }
}


const apiAddGroupEvent = async (id, data) => {

  try {
    const result = await axios.post(`/v1/course/${id}/group_event`, data, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      }
    })
    return result
  } catch (error) {
    return _optionalChain([error, 'optionalAccess', _5 => _5.response, 'optionalAccess', _6 => _6.data]);
  }
}


const apiDelGroupEvent = async (id, gv_id) => {

  try {
    const result = await axios.delete(`/v1/course/${id}/group_event/${gv_id}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      }
    })
    return result
  } catch (error) {
    return _optionalChain([error, 'optionalAccess', _7 => _7.response, 'optionalAccess', _8 => _8.data]);
  }
}

const apiEditGroupEvent = async (id, group_event_id, data) => {

  try {
    const result = await axios.put(`/v1/course/${id}/group_event/${group_event_id}`, data, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      }
    })
    return result
  } catch (error) {
    return _optionalChain([error, 'optionalAccess', _9 => _9.response, 'optionalAccess', _10 => _10.data]);
  }
}


const apiGetGroup = async (course_id, course_group_event_id, page, limit, orderby, search) => {
  try {
    const result = await axios.get(`/v1/course/${course_id}/group_event/${course_group_event_id}/group?page=${page}&limit=${limit}&order_by=${orderby}&search_option=${search} `, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      }
    })
    return result
  } catch (error) {
    return _optionalChain([error, 'optionalAccess', _11 => _11.response, 'optionalAccess', _12 => _12.data]);
  }
}


const apiAddGroup = async (course_id, course_group_event_id, data) => {

  try {
    const result = await axios.post(`/v1/course/${course_id}/group_event/${course_group_event_id}/group`, data, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      }
    })
    return result
  } catch (error) {
    return _optionalChain([error, 'optionalAccess', _13 => _13.response, 'optionalAccess', _14 => _14.data]);
  }
}

const apiEditGroup = async (course_id, course_group_event_id, course_group_id, data) => {

  try {
    const result = await axios.put(`/v1/course/${course_id}/group_event/${course_group_event_id}/group/${course_group_id}`, data, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      }
    })
    return result
  } catch (error) {
    return _optionalChain([error, 'optionalAccess', _15 => _15.response, 'optionalAccess', _16 => _16.data]);
  }
}

const apiDeleteGroup = async (course_id, course_group_event_id, course_group_id) => {

  try {
    const result = await axios.delete(`/v1/course/${course_id}/group_event/${course_group_event_id}/group/${course_group_id}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      }
    })
    return result
  } catch (error) {
    return _optionalChain([error, 'optionalAccess', _17 => _17.response, 'optionalAccess', _18 => _18.data]);
  }
}

export {
  apiGetGroupEvent,
  apiAddGroupEvent,
  apiDelGroupEvent,
  apiEditGroupEvent,
  apiGetGroup,
  apiAddGroup,
  apiEditGroup,
  apiDeleteGroup,
  apiGetOwnGroupSocial 
}